import { CSSProperties, ChangeEvent, RefObject, SyntheticEvent, useEffect, useRef, useState } from "react"
import { Button, Modal, Form, Table, Card, Alert, Tabs, Tab, Spinner } from "react-bootstrap"
import DeleteConfirmation from "../../components/DeleteConfirmation"
import AddOrRemoveLanguages, { LanguageActionTypes } from "../../components/AddOrRemoveLanguages"
// import Pagination from "../../components/Pagination"
import Configs from "../../Configs"
import useGlobalContext from "../../hooks/useGlobalContext"
import AreaService, { IArea } from "../../services/AreaService"
import AreaSelect from "../../components/AreaSelect"
import useAuthContext from "../../hooks/useAuthContext"
import Permissions from "../../constants/Permissions"
import AreaMapModal from "./AreaMapModal"
import AreaPhotosModal from "./AreaPhotosModal"

interface IAreasModalProps {
    placeId: number | null
    show: boolean
    title: string
    onClose: () => void
}

function AreasModal(props: IAreasModalProps) {
    const { hasPermission } = useAuthContext()
    const { languages } = useGlobalContext()

    const [tableData, setTableData] = useState({
        data: new Array<IArea>(),
        hasNext: false,
        hasPrevious: false,
        pageIndex: 1,
        pageSize: Configs.DEFAULT_PAGE_SIZE,
        totalPages: 0,
        totalRecords: 0
    })

    const initFormData: IArea = {
        id: null,
        name: "",
        thumbnail: "",
        parentId: null,
        orderNumber: null,
        isUsed: false,
        placeId: props.placeId || 0,
        translations: languages.filter(x => x.code === Configs.DEFAULT_LANGUAGE_CODE).map(x => {
            return {
                areaId: null,
                languageId: x.id || 0,
                name: "",
                language: x
            }
        })
    }

    const [message, setMessage] = useState("")
    const [messageFormModal, setMessageFormModal] = useState("")
    const [formData, setFormData] = useState(initFormData)
    // const [currentPageIndex, setCurrentPageIndex] = useState(1)
    const [deletedItem, setDeletedItem] = useState({
        id: 0,
        name: ""
    })

    // const keywordRef = useRef<HTMLInputElement>(null)
    const formRef = useRef<HTMLFormElement>(null)
    const [validatedForm, setValidatedForm] = useState(false)
    const [activeTabKey, setActiveTabKey] = useState(languages.find(x => x.code === Configs.DEFAULT_LANGUAGE_CODE)?.id?.toString())

    // const FilterFn = async (pageIndex: number) => {
    //     if (props.placeId && props.show) {
    //         let pageSize = Configs.DEFAULT_PAGE_SIZE
    //         let keyword = keywordRef.current?.value || ""

    //         const res = await AreaService.filter(props.placeId, pageIndex, pageSize, keyword)

    //         if (res?.isSuccess) {
    //             setTableData(res.data)
    //         } else {
    //             console.log(res?.message)
    //         }

    //         setCurrentPageIndex(pageIndex)
    //     } else {
    //         setTableData({
    //             data: new Array<IArea>(),
    //             hasNext: false,
    //             hasPrevious: false,
    //             pageIndex: 1,
    //             pageSize: Configs.DEFAULT_PAGE_SIZE,
    //             totalPages: 0,
    //             totalRecords: 0
    //         })
    //     }
    // }

    const ListFn = async () => {
        if (props.placeId && props.show) {
            const res = await AreaService.list(props.placeId, null)

            if (res?.isSuccess) {
                setTableData({ ...tableData, data: res.data })
            } else {
                console.log(res?.message)
            }
        } else {
            setTableData({
                data: new Array<IArea>(),
                hasNext: false,
                hasPrevious: false,
                pageIndex: 1,
                pageSize: Configs.DEFAULT_PAGE_SIZE,
                totalPages: 0,
                totalRecords: 0
            })
        }
    }

    useEffect(() => {
        // keywordRef.current?.focus()
        // FilterFn(1)

        ListFn()
    }, [props.placeId, props.show])

    // const handleSearch = () => {
    //     FilterFn(1)
    // }

    // const handleSearchInputKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
    //     if (e.key === 'Enter') {
    //         FilterFn(1)
    //     }
    // }

    // const handlePageChange = (pageNumber: number) => {
    //     FilterFn(pageNumber)
    // }

    const handleFormControlChange = (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
        if (e.target.name === "orderNumber" || e.target.name === "parentId") {
            setFormData({ ...formData, [e.target.name]: e.target.value ? parseInt(e.target.value) : null })
        } else {
            setFormData({ ...formData, [e.target.name]: e.target.value })
        }
    }

    const handleTranslateFormControlChange = (e: ChangeEvent<HTMLInputElement>, languageId: number | null) => {
        setFormData({ ...formData, translations: formData.translations.map(x => x.languageId === languageId ? { ...x, [e.target.name]: e.target.value } : x) })
    }

    const handleAddNew = () => {
        setThumbnail(null)
        setFormData(initFormData)

        handleShowModal()
    }

    const handleEdit = async (id: number | null) => {
        setThumbnail(null)

        if (props.placeId && id) {
            const res = await AreaService.get(props.placeId, id)

            if (res?.isSuccess) {
                setFormData(res.data)
                setActiveTabKey(res.data.translations[0]?.languageId?.toString())

                handleShowModal()
            } else {
                console.log(res?.message)
            }
        }
    }

    const [processing, setProcessing] = useState<boolean>(false)
    const handleSave = async (e: SyntheticEvent) => {
        e.preventDefault()

        if (!processing) {
            setProcessing(true)
            if (props.placeId) {
                if (formRef.current?.checkValidity()) {
                    var frmData = new FormData()
                    if (thumbnail !== null) {
                        frmData.append("Thumbnail", thumbnail)
                    }
                    frmData.append("OrderNumber", formData.orderNumber ? formData.orderNumber.toString() : "")
                    frmData.append("ParentId", formData.parentId ? formData.parentId.toString() : "")
                    frmData.append("AreaId", formData.placeId ? formData.placeId.toString() : "")

                    formData.translations.forEach((item, index) => {
                        if (item.areaId) {
                            frmData.append(`Translations[${index}].AreaId`, item.areaId.toString())
                        }
                        frmData.append(`Translations[${index}].LanguageId`, item.languageId.toString())
                        frmData.append(`Translations[${index}].Name`, item.name.toString())
                    })

                    try {
                        if (formData.id && formData.id > 0) {
                            const res = await AreaService.update(props.placeId, formData.id, frmData)

                            if (res?.isSuccess) {
                                // FilterFn(currentPageIndex)
                                ListFn()
                                handleCloseModal()
                                setMessage(res.message)
                            } else {
                                setMessageFormModal(res?.message)
                            }
                        } else {
                            const res = await AreaService.create(props.placeId, frmData)

                            if (res?.isSuccess) {
                                // FilterFn(1)
                                ListFn()
                                handleCloseModal()
                                setMessage(res.message)
                            } else {
                                setMessageFormModal(res?.message)
                            }
                        }
                    } catch (error) {
                        console.log(error)
                    }
                } else {
                    setValidatedForm(true)
                }
            }
            setProcessing(false)
        }
    }

    const [showModal, setShowModal] = useState(false)
    const handleCloseModal = () => {
        setShowModal(false)
        setValidatedForm(false)
        setMessageFormModal("")
    }
    const handleShowModal = () => {
        setThumbnail(null)
        setMessage("")
        setShowModal(true)
    }

    const modalTitle = (formData.id || 0) > 0 ? "Edit Area" : "New Area"

    const [displayConfirmationModal, setDisplayConfirmationModal] = useState(false)

    const hideConfirmationModal = () => {
        setDeletedItem({
            id: 0,
            name: ""
        })

        setDisplayConfirmationModal(false)
    }

    const showDeleteConfirmation = (id: number | null, name: string) => {
        setDeletedItem({
            id: id || 0,
            name: name
        })

        setDisplayConfirmationModal(true)
        setMessage("")
    }

    const handleDelete = async () => {
        if (props.placeId && deletedItem.id > 0) {
            const res = await AreaService.delete(props.placeId, deletedItem.id)

            if (res?.isSuccess) {
                // FilterFn(currentPageIndex)
                ListFn()
            }

            hideConfirmationModal()
            setMessage(res.message)
        }
    }

    const handleIsUsedSwitch = async (id: number | null) => {
        if (props.placeId && id) {
            const res = await AreaService.changeIsUsed(props.placeId, id)

            if (res?.isSuccess) {
                // FilterFn(currentPageIndex)
                ListFn()
            } else {
                console.log(res?.message)
            }
        }
    }

    const handleLanguagesChange = async (languageId: number, action: LanguageActionTypes) => {
        if (action === "Add") {
            const newLang = languages.find(x => x.id === languageId)
            if (newLang) {
                if (formData.translations.filter(x => x.languageId === newLang.id).length === 0) {
                    const newFormData = { ...formData }

                    newFormData.translations.push({
                        areaId: null,
                        languageId: newLang.id || 0,
                        name: "",
                        language: newLang
                    })

                    setFormData(newFormData)
                    setActiveTabKey(newLang.id?.toString())
                }
            }
        } else {
            const newTranslations = formData.translations.filter(x => x.languageId !== languageId)

            setFormData({ ...formData, translations: newTranslations })
            setActiveTabKey(newTranslations[0]?.languageId.toString())
        }
    }

    const [thumbnail, setThumbnail] = useState(null as any)

    const handleThumbnailChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files?.length) {
            setThumbnail(e.target.files[0])
        } else {
            setThumbnail(null)
        }
    }

    //TreeTable
    const CreateTreeTableRow = () => {
        var options: any[] = []

        const areas: IArea[] = tableData.data
        var roots = areas.filter(x => x.parentId === null)
        var level: number = 1

        CreateTableRow(areas, roots, level, options)

        return options
    }

    const CreateTableRow = (areas: IArea[], roots: IArea[], level: number, options: any[]) => {
        roots.forEach(item => {
            options.push(
                <tr key={item.id}>
                    <td>{item.thumbnail && <img src={`${Configs.API_BASE_URL}${item.thumbnail}`} style={{ maxWidth: "100%" }} alt={item.name} />}</td>
                    <td style={CreateIndentedRowStyle(level)}>
                        <h6>{item.name}</h6>
                        {hasPermission(Permissions.AreaMaps.View) &&
                            <Button variant="default" size="sm" onClick={() => handleShowAreaMapModal(item.id, item.name)}>
                                <i className="fas fa-map text-info"></i> <span className="text-muted" style={{ fontSize: "11px" }}>Map</span>
                            </Button>
                        }
                        {hasPermission(Permissions.AreaPhotos.View) &&
                            <Button variant="default" size="sm" onClick={() => handleShowAreaPhotosModal(item.id, item.name)}>
                                <i className="far fa-images text-info"></i> <span className="text-muted" style={{ fontSize: "11px" }}>Photos</span>
                            </Button>
                        }
                    </td>
                    <td>{item.orderNumber}</td>
                    <td style={{ textAlign: "center" }}>
                        <Form.Check type="switch" id={"am_isused_" + item.id} checked={item.isUsed} onChange={() => handleIsUsedSwitch(item.id)} label="Published" disabled={!hasPermission(Permissions.Areas.Edit)} />
                    </td>
                    <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                        {hasPermission(Permissions.Areas.Edit) &&
                            <Button variant="warning" className="mr-1" size="sm" onClick={() => handleEdit(item.id)}><i className="fas fa-pencil-alt"></i> Edit</Button>
                        }
                        {hasPermission(Permissions.Areas.Delete) &&
                            <Button variant="danger" size="sm" onClick={() => showDeleteConfirmation(item.id, item.name)}><i className="fas fa-trash-alt"></i> Delete</Button>
                        }
                    </td>
                </tr>
            )

            var parents = areas.filter(x => x.parentId === item.id)
            CreateTableRow(areas, parents, level + 1, options)
        })
    }

    const CreateIndentedRowStyle = (level: number) => {
        let style: CSSProperties = {
            whiteSpace: "nowrap",
            textIndent: (level - 1) * 30
        }
        return style
    }

    const [selectedItem, setSelectedItem] = useState({
        id: 0,
        name: ""
    })

    //AreaMap
    const [showAreaMapModal, setShowAreaMapModal] = useState(false)
    const handleCloseAreaMapModal = () => {
        setShowAreaMapModal(false)
        setSelectedItem({
            id: 0,
            name: ""
        })
    }

    const handleShowAreaMapModal = (id: number | null, name: string) => {
        if (id) {
            setSelectedItem({
                id: id || 0,
                name: name
            })
            setShowAreaMapModal(true)
        }
    }

    // AreaPhotos
    const [showAreaPhotosModal, setShowAreaPhotosModal] = useState(false)
    const handleCloseAreaPhotosModal = () => {
        setShowAreaPhotosModal(false)
        setSelectedItem({
            id: 0,
            name: ""
        })
    }

    const handleShowAreaPhotosModal = (id: number | null, name: string) => {
        if (id) {
            setSelectedItem({
                id: id || 0,
                name: name
            })
            setShowAreaPhotosModal(true)
        }
    }

    return (
        <>
            <Modal show={props.show} onHide={props.onClose} backdrop="static" keyboard={false} size="xl">
                <Modal.Header closeButton className="p-2">
                    <Modal.Title><i className="fas fa-kaaba"></i> Areas <span>|</span> {props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    <Card className="m-0" style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
                        <Card.Header>
                            {hasPermission(Permissions.Areas.Create) &&
                                <Button variant="info" size="sm" onClick={handleAddNew}>
                                    <i className="fas fa-plus"></i> Add new
                                </Button>
                            }

                            {/* <div className="card-tools">
                                <InputGroup size="sm">
                                    <Form.Control
                                        type="search"
                                        placeholder="Search"
                                        ref={keywordRef as RefObject<HTMLInputElement>}
                                        onKeyUp={handleSearchInputKeyPress}
                                    />
                                    <Button variant="info" size="sm" onClick={handleSearch}>
                                        <i className="fas fa-search"></i>
                                    </Button>
                                </InputGroup>
                            </div> */}
                        </Card.Header>
                        <Card.Body>
                            {message !== "" && <Alert variant="info" onClose={() => setMessage("")} dismissible>{message}</Alert>}
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <th style={{ textAlign: "center", width: "160px" }}>Thumbnail</th>
                                        <th>Name</th>
                                        <th style={{ textAlign: "center", width: "130px" }}>Order Number</th>
                                        <th style={{ textAlign: "center", width: "100px" }}>Status</th>
                                        <th style={{ textAlign: "center", width: "80px" }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        // tableData.data.map(item =>
                                        //     <tr key={item.id}>
                                        //         <td>{item.thumbnail && <img src={`${Configs.API_BASE_URL}${item.thumbnail}`} style={{ maxWidth: "100%" }} />}</td>
                                        //         <td>{item.name}</td>
                                        //         <td>{item.orderNumber}</td>
                                        //         <td style={{ textAlign: "center" }}>
                                        //             <Form.Check type="switch" checked={item.isUsed} onChange={() => handleIsUsedSwitch(item.id)} label="Published" />
                                        //         </td>
                                        //         <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                                        //             <Button variant="warning" className="m-1" size="sm" onClick={() => handleEdit(item.id)}><i className="fas fa-pencil-alt"></i> Edit</Button>
                                        //             <Button variant="danger" size="sm" onClick={() => showDeleteConfirmation(item.id, item.name)}><i className="fas fa-trash-alt"></i> Delete</Button>
                                        //         </td>
                                        //     </tr>
                                        // )
                                        CreateTreeTableRow()
                                    }
                                </tbody>
                            </Table>
                        </Card.Body>
                        {/* <Card.Footer>
                            <Pagination hasNext={tableData.hasNext} hasPrevious={tableData.hasPrevious} pageIndex={tableData.pageIndex} pageSize={tableData.pageSize} totalPages={tableData.totalPages} totalRecords={tableData.totalRecords} handlePageChange={handlePageChange} />
                        </Card.Footer> */}
                    </Card>
                </Modal.Body>
            </Modal>

            <Modal show={showModal} onHide={handleCloseModal} backdrop="static" keyboard={false} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{modalTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AddOrRemoveLanguages selectedLanguages={formData.translations.map(x => x.language)} onChange={handleLanguagesChange}></AddOrRemoveLanguages>
                    <Form noValidate validated={validatedForm} ref={formRef as RefObject<HTMLFormElement>}>
                        <Form.Group controlId="formFile" className="mb-3">
                            <Form.Label>Thumbnail</Form.Label>
                            <Card className="shadow-0">
                                {formData.thumbnail && <Card.Img variant="top" src={`${Configs.API_BASE_URL}${formData.thumbnail}`} style={{ width: "inherit", maxWidth: "300px", margin: "auto" }} />}
                                <Card.Body className="p-2">
                                    <Form.Control type="file" onChange={handleThumbnailChange} accept={Configs.IMAGE_EXTENSION} />
                                </Card.Body>
                            </Card>
                        </Form.Group>
                        <Tabs activeKey={activeTabKey} onSelect={(k) => setActiveTabKey(k || undefined)}>
                            {
                                formData.translations.sort((a, b) => { return (a.language.orderNumber || 0) - (b.language.orderNumber || 0) }).map(translate => {
                                    return (
                                        <Tab
                                            key={translate.languageId}
                                            eventKey={(translate.languageId).toString()}
                                            title={translate.language.name}
                                            className="p-3"
                                        >
                                            <Form.Group className="mb-3" controlId={"name_" + translate.languageId}>
                                                <Form.Label>Name</Form.Label>
                                                <Form.Control as="textarea" rows={2} type="text" name="name" required value={translate?.name || ""} onChange={(e) => handleTranslateFormControlChange(e as any, translate.languageId)} />
                                                <Form.Control.Feedback type="invalid">Name is required.</Form.Control.Feedback>
                                            </Form.Group>
                                        </Tab>
                                    )
                                })
                            }
                        </Tabs>
                        <AreaSelect name="parentId" placeId={props.placeId} excludeBranchId={formData.id} value={formData.parentId} onChange={handleFormControlChange}></AreaSelect>
                        <Form.Group className="mt-3" controlId="orderNumber">
                            <Form.Label>Order Number</Form.Label>
                            <Form.Control type="number" name="orderNumber" value={formData.orderNumber || ""} onChange={(e) => handleFormControlChange(e as any)} />
                        </Form.Group>
                    </Form>
                    {messageFormModal !== "" && <Alert variant="danger" onClose={() => setMessageFormModal("")} dismissible>{messageFormModal}</Alert>}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" onClick={handleCloseModal}><i className="fas fa-times"></i> Cancel</Button>
                    <Button variant="info" onClick={handleSave} disabled={processing}>
                        {processing ? <><Spinner animation="border" size="sm" /> Saving...</> : <><i className="fas fa-save"></i> Save</>}
                    </Button>
                </Modal.Footer>
            </Modal>

            <DeleteConfirmation show={displayConfirmationModal} onConfirm={handleDelete} onHide={hideConfirmationModal} id={deletedItem.id} name={deletedItem.name} />
            <AreaMapModal areaId={selectedItem.id} title={selectedItem.name} show={showAreaMapModal} onClose={handleCloseAreaMapModal}></AreaMapModal>
            <AreaPhotosModal areaId={selectedItem.id} title={selectedItem.name} show={showAreaPhotosModal} onClose={handleCloseAreaPhotosModal}></AreaPhotosModal>
        </>
    )
}

export default AreasModal